const colors = {
    yellow: {
        light: '#fffcee',
        base: '#fff980',
        contrastText: '#000',
    },
    blue: {
        light: '#e6f4ff',
        base: '#98d4ff',
        dark: '#2d67b8',
        contrastText: '#fff',
    },
    teal: {
        light: '#cfeef1',
        base: '#80cfc2',
        dark: '#006368',
        contrastText: '#fff',
    },
    mint: {
        light: '#e1f3f0',
        base: '#c1e6e0',
        contrastText: '#000',
    },
    pink: {
        light: '#feefea',
        base: '#fed0bd',
        dark: '#c8483d',
        contrastText: '#fff',
    },
    gray: {
        light: '#F4F5F5',
        base: '#E1E2E2',
        dark: '#000000',
        contrastText: '#fff',
    },
};
export default colors;
//# sourceMappingURL=colors.js.map